import React, { createRef } from 'react';
import SelectionList from '../../selectionList/SelectionList';
import FilterValueDateTimeField from './FilterValueDateTimeField';
import FilterValueDateTimeDiapason from './FilterValueDateTimeDiapason';
import {findConditionIndex} from './util';
import { getCurrentResource } from '../../../util/tools';

import {
	CONDITION_NONE,
	CONDITION_IS_NOT_NULL,
	CONDITION_IS_NULL,
	CONDITION_EQUALS,
	CONDITION_NOT_EQUALS,
	CONDITION_GREATER,
	CONDITION_GREATER_EQUALS,
	CONDITION_LESS,
	CONDITION_LESS_EQUALS,
	CONDITION_BETWEEN,
	CONDITION_NOT_BETWEEN
} from './util';

class FilterDateTime extends React.Component {

	/*
		props:
			filter
			filterIndex
			holder
			rateView
			handleFilterChanged
	*/
	constructor(props) {
		super(props);
		props.holder.registerFilterComponent(this, props.filterIndex); 
		this.refConditionList = React.createRef();
		this.resCondition = getCurrentResource().components.rateview.conditions.conditions; 
		this.conditions = [
			{id: CONDITION_NONE, title: this.resCondition.none.title},
		];
		var filter = props.filter;
		for(let conditionId of filter.filterModel.listConditions) {
			this.conditions.push(
				{id: conditionId, title: this.resCondition[conditionId].title}
			);
		}

		var conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		this.state = {
			filter: filter,
			conditionIndex: conditionIndex
		}
	}
	updateFilter = (filter) => {
		var conditionIndex = findConditionIndex(this.conditions, filter.conditionId, 0);
		this.refConditionList.current.setSelectedIndex( conditionIndex );
		this.setState({filter: filter, conditionIndex: conditionIndex});
	}
	
	handleConditionSelection = (index) => {
		if( index == -1 )
			index = 0;
		var cond = this.conditions[index];
		this.props.filter.conditionId = cond.id;
		this.setState({conditionIndex: index}, this.handleFilterChanged);
	}	
	handleFilterChanged = (filter) => {
		if( ! filter )
			filter = this.props.filter;

		if( filter.conditionId == CONDITION_NONE ) {
			filter.active = false;
			filter.bodyText = '';
		} else if( filter.conditionId == CONDITION_IS_NOT_NULL || filter.conditionId == CONDITION_IS_NULL ) {
			filter.active = true;
			filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title;
		} else if( filter.conditionId == CONDITION_BETWEEN || filter.conditionId == CONDITION_NOT_BETWEEN ) {
			if( filter.listValue.length < 2 || 
					filter.listValue[0].trim() == '' && filter.listValue[1].trim() == '') 
			{
				filter.active = false;
				filter.bodyText = '';
			} else {
				filter.active = true;
				filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title + ' [ ';
				filter.bodyText += "'" + filter.listValue[0] + "'";
				filter.bodyText += " ... ";
				filter.bodyText += "'" + filter.listValue[1] + "'";
			}
		} else {
			if( filter.listValue.length == 0 || filter.listValue[0].trim() == '' ) {
				filter.active = false;
				filter.bodyText = '';
			} else {
				filter.active = true;
				filter.bodyText = filter.title + ' ' + this.resCondition[filter.conditionId].title + ' ';
				filter.bodyText += "'" + filter.listValue[0] + "'";
			}
		}

		this.props.handleFilterChanged( filter );
	}
	
	render() {
		return (
			<div style={{display: 'flex'}}>
				<div style={{width: '250px', border: '1px solid black'}}>
					<SelectionList 
						ref={this.refConditionList}
						items={this.conditions} 
						handleItemSelection={this.handleConditionSelection}
						selectedIndex={this.state.conditionIndex} 
					/>
				</div>
				<div style={{flexGrow: '100', marginLeft: '10px'}}>
					<FilterValue holder={this} />
				</div>
			</div>
		);
	}
}

function FilterValue(props) {
	var holder = props.holder;
	var cond = holder.conditions[ holder.state.conditionIndex ];
	var fvDateConditions = [ 
		CONDITION_EQUALS, CONDITION_NOT_EQUALS,
		CONDITION_GREATER, CONDITION_GREATER_EQUALS,
		CONDITION_LESS, CONDITION_LESS_EQUALS,
	];
	var fvDateDiapasonConditions = [ 
		CONDITION_BETWEEN, CONDITION_NOT_BETWEEN
	];
	if( fvDateConditions.includes( cond.id ) ) {
		return <FilterValueDateTimeField filter={holder.props.filter} handleFilterChanged={holder.handleFilterChanged} />
	} else if( fvDateDiapasonConditions.includes( cond.id ) ) {
		return <FilterValueDateTimeDiapason filter={holder.props.filter} handleFilterChanged={holder.handleFilterChanged} />
	} else {
		return null;
	}
}

export default FilterDateTime;
